﻿const totalDeliveryEvents = {
    "MPC_Result": {
       param: 'buildercommunitylist',
       getAttributes: (dataset) => `${dataset.builderId} ${dataset.communityId},` 
    },
    "COMR": {
        param: 'buildercommunitylist',
        getAttributes: (dataset) => `${dataset.builderId} ${dataset.communityId},` 
     },
     "HOMEHR": {
        param: 'homeList',
        getAttributes: (dataset) => {
            if (dataset.specId) {
                return `${dataset.specId} s,`;
            }

            return `${dataset.planId} p,`;
        } 
     }
};

const getEvent = (eventLabel, datasets) => {
    const event = {};
    if (datasets.length !== 0) {
        const config = totalDeliveryEvents[eventLabel];
        event[config.param] = '';
        datasets.forEach(dataset => { 
            event[config.param] += config.getAttributes(dataset);
        });
        event[config.param] = event[config.param].slice(0,-1);
        // Not best approach, it should be consistent on every card, but as a hotfix urgency I will
        // manage it on my next pull request.
        event.market = datasets[0].market || datasets[0].marketId;
    }

    return event;
};

export default getEvent;